<template>
  <div class="Others11Charts">
    <TableDateDownSelect
      v-if="value.isShowRightDropDownBox"
      :tabselectData="tabselectData"
      :pickerType="pickerType"
      :selectApi="selectApi"
      @tabSelectChange="tabSelectChange"
    >
    </TableDateDownSelect>
    <div class="male-female" :class="getStyle('title')">
      <div class="male human">
        <div class="img-data">
          <img
            v-if="ProjectInfo.Style.componentName == 'V11Style'"
            src="../../../assets/img/male_2.png"
            alt=""
          />
          <img v-else src="../../../assets/img/male_1.png" alt="" />

          <div class="data">
            <div class="percentage" :style="getxFontSize()">
              <vue-animate-number :value="male" :formatValue="formatToPrice" :duration="3000">
              </vue-animate-number>
              %
            </div>

            <span
              :style="{
                fontSize: `${$w_Ratio(4 + getShowfontSizeBase(), $store)}px`,
              }"
              class="sex"
            >
              男性
            </span>
          </div>
        </div>

        <!-- 进度条 -->

        <div class="progress">
          <div class="p-data d-male" :style="{ width: `${male}%` }"></div>
        </div>
      </div>

      <div class="female human">
        <div class="img-data">
          <img
            v-if="ProjectInfo.Style.componentName == 'V11Style'"
            src="../../../assets/img/female_2.png"
            alt=""
          />
          <img v-else src="../../../assets/img/female_1.png" alt="" />

          <div class="data">
            <div class="percentage" :style="getyFontSize()">
              <vue-animate-number :value="female" :formatValue="formatToPrice" :duration="3000">
              </vue-animate-number>
              %
            </div>

            <span
              :style="{
                fontSize: `${$w_Ratio(4 + getShowfontSizeBase(), $store)}px`,
              }"
              class="sex"
            >
              女性
            </span>
          </div>
        </div>

        <!-- 进度条 -->

        <div class="progress">
          <div class="p-data d-famale" :style="{ width: `${female}%` }"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueAnimateNumber from '../../../count-animate-number/AnimatedNumber';
import { getFilterValue } from '../../../utils/tool';
import { request } from '../../../common/request';
import TableDateDownSelect from '@/components/common/TableDateDownSelect/TableDateDownSelect.vue';
// import { CountTo } from 'vue3-count-to';

export default {
  name: 'Others11Charts',
  components: {
    // CountTo
    VueAnimateNumber,
    TableDateDownSelect,
  },
  props: {
    ProjectInfo: Object,
    Configuration: Object,
    ComboBoxCharts: Object,
  },
  data() {
    return {
      echartsOptions: {},
      apiIntervalTaskID: null,
      staticIntervalTaskID: null,
      data: [],
      loading: true, // 加载对象
      params: {}, // 请求参数
      paramsCopy: {},
      male: 0,
      female: 0,
      fontStyle: {},
      decimalpoint1: 1,
      value: {
        isShowRightDropDownBox: false,
      },
      tabselectData: [], // 下拉选择的时间数据d
      selectApi: '',
    };
  },
  watch: {
    Configuration: {
      deep: true,
      handler: function () {
        this.getxFontSize();
        this.getyFontSize();
        if (this.Configuration.isScaling) {
          console.log('scale');
        } else if (this.Configuration.isMoving) {
          console.log('mov');
        } else {
          this.debounce_subscribeConfigurationChange();
        }
      },
    },
  },
  created() {
    clearInterval(this.apiIntervalTaskID);
    clearInterval(this.staticIntervalTaskID);
    clearInterval(this.staticIntervalTaskID2);
    this.registerDebounceAndThrottle();
  },
  mounted() {
    this.$nextTick(() => {
      this.startApiIntervalTask();
      this.startStaticIntervalTask();
    });
    this.getApiDataResByFilterAndResponseQuery();
    // 默认取api参数
    let that = this;
    let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
    // 判断 数据 为本地或动态
    this.selectApi = ChartsData;
    let params = ChartsData?.apiData?.apiPostParams || '{}';
    this.params = eval('(' + params + ')');
    this.paramsCopy = eval('(' + params + ')');
  },
  beforeUnmount() {
    clearInterval(this.apiIntervalTaskID);
    clearInterval(this.staticIntervalTaskID);
    clearInterval(this.staticIntervalTaskID2);
    this.unRegisterDebounceAndThrottle();
  },
  computed: {
    style() {
      return this.ProjectInfo.Style.componentName;
    },
  },
  filters: {
    dealData(data) {
      console.log(data, '-----------');
      return Number(data).toFixed(2);
    },
  },
  methods: {
    tabSelectChange(e) {
      console.log(e, '1646463144764163');
      // 判断是否使用静态数据
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      if (ChartsData?.currenEntry === 'staticData') {
        this.echartsClick = e;
      } else {
        this.params = this.getFilterValue(e);
        this.startApiIntervalTask();
      }
    },
    getFilterValue(e) {
      return getFilterValue(e);
    },
    formatToPrice(value) {
      //使用tofixed（0）限制跳动的小数位数
      if (value < 100) {
        return `<span>${Number(value).toFixed(1)}</span>`;
      } else {
        return `<span>${Number(value).toFixed(0)}</span>`;
      }
    },
    getPadding(a, b) {
      return {
        padding: `${this.$w_Ratio(a + this.getShowfontSizeBase(), this.$store)}px 
               ${this.$w_Ratio(b + this.getShowfontSizeBase(), this.$store)}px`,
      };
    },
    getStyle(e = '') {
      let style = {};
      let bool = e == 'title';
      switch (this.style) {
        case 'V1Style':
          style = {};
          if (bool) style['V1StyleTitle'] = true;
          style['V1Style'] = true;
          break;
        case 'V2Style':
          style = {};
          if (bool) style['V2StyleTitle'] = true;
          style['V2Style'] = true;
          break;
        case 'V3Style':
          style = {};
          if (bool) style['V3StyleTitle'] = true;
          style['V3Style'] = true;
          break;
        case 'V4Style':
          style = {};
          if (bool) style['V4StyleTitle'] = true;
          style['V4Style'] = true;
          break;
        case 'V5Style':
          style = {};
          if (bool) style['V5StyleTitle'] = true;
          style['V5Style'] = true;
          break;
        case 'V6Style':
          style = {};
          if (bool) style['V6StyleTitle'] = true;
          style['V6Style'] = true;
          break;
        case 'V7Style':
          style = {};
          if (bool) style['V7StyleTitle'] = true;
          style['V7Style'] = true;
          break;
        case 'V8Style':
          style = {};
          if (bool) style['V8StyleTitle'] = true;
          style['V8Style'] = true;
          break;
        case 'V9Style':
          style = {};
          if (bool) style['V9StyleTitle'] = true;
          style['V9Style'] = true;
          break;
        case 'V10Style':
          style = {};
          if (bool) style['V10StyleTitle'] = true;
          style['V10Style'] = true;
          break;
        case 'V11Style':
          style = {};
          if (bool) style['V11StyleTitle'] = true;
          style['V11Style'] = true;
          break;
        default:
          break;
      }
      return style;
    },
    // 根据不同的风格取不同的颜色
    setStyle() {
      let color;
      switch (this.style) {
        case 'V1Style':
          color = '#eee';
          break;
        case 'V2Style':
          color = '#eee';
          break;
        case 'V3Style':
          color = '#7fdfff';
          break;
        case 'V4Style':
          color = '#b044f8';
          break;
        case 'V5Style':
          color = '#09af60';
          break;
        default:
          color = '#eee';
          break;
      }
      this.$refs['loading-box'].style.setProperty('--color', color); // 给变量赋值
    },
    getxFontSize() {
      return {
        'font-size': this.fontStyle.xAxisSize + 'px',
        color: this.fontStyle.xAxisColor,
      };
    },
    getyFontSize() {
      return {
        'font-size': this.fontStyle.yAxisSize + 'px',
        color: this.fontStyle.yAxisColor,
      };
    },
    getShowfontSizeBase() {
      return Math.round(this.Configuration.style.height / 20);
    },
    registerDebounceAndThrottle() {
      this.debounce_subscribeConfigurationChange = this.$_.debounce(this.subscribeConfigurationChange, 500);
    },
    unRegisterDebounceAndThrottle() {
      this.debounce_subscribeConfigurationChange.cancel();
    },
    // 订阅Configuration变化将会执行的函数
    subscribeConfigurationChange() {
      clearInterval(this.apiIntervalTaskID);
      clearInterval(this.staticIntervalTaskID);
      clearInterval(this.staticIntervalTaskID2);
      this.startApiIntervalTask();
      this.startStaticIntervalTask();
    },
    setEchartsOptions(ParamData = null) {
      let grid = {};
      let chartColor = [];
      let source = [];
      let seriesList = [];
      let tableDownData = [];
      let fontStyle = {
        titleColor: '#ccc',
        titleSize: 16,
        xAxisColor: '#c3dbff',
        xAxisSize: 12,
        yAxisColor: '#c3dbff',
        yAxisSize: 12,
      };

      if (this.Configuration.propertyData.chartsColor.value.chartColor) {
        chartColor = this.Configuration.propertyData.chartsColor.value.chartColor;
      }
      if (this.Configuration.propertyData.chartsGrid.value) {
        grid = this.Configuration.propertyData.chartsGrid.value;
      }
      if (ParamData && ParamData.source && ParamData.seriesList) {
        source = ParamData.source;
        seriesList = ParamData.seriesList;
        tableDownData = ParamData?.tableDownData; // 日期选择需要的
      }
      if (this.Configuration.propertyData.fontStyle.value) {
        fontStyle = this.Configuration.propertyData.fontStyle.value;
        this.fontStyle = fontStyle;
      }
      if (this.Configuration.propertyData?.chartsRightDropDown?.value) {
        this.value = this.Configuration.propertyData.chartsRightDropDown.value;
      }

      // 时间
      let that = this;
      function dealSelectData() {
        let tabselectData = [];
        let pickerType = [];
        if (tableDownData) {
          tableDownData.forEach(item_t => {
            if (item_t[2]) {
              tabselectData.push(
                item_t[0], //  tabMont  tabYear
                item_t[2],
              );
            } else {
              tabselectData.push(
                item_t[0], //  tabMont  tabYear
              );
            }

            pickerType.push(item_t[1]);
          });
        }

        that.tabselectData = tabselectData;
        that.pickerType = pickerType;
      }
      if (this.value.isShowRightDropDownBox) {
        dealSelectData();
      }

      this.data = source;
      // 关闭加载
      this.$nextTick(() => {
        this.loading = false;
      });

      console.log(source, 'aaaaaa');
      console.log(seriesList);
      console.log(chartColor);
      console.log(fontStyle);
      console.log(grid);

      let total = 0;
      source.forEach(item => {
        if (item.y == null) {
          total = 0;
        } else {
          total += Number(item.y);
        }
      });
      if ((source[0].y == 0 && source[1].y == 0) || (source[0].y == null && source[1].y == null)) {
        this.male = source[0].y;
        this.female = source[1].y;
        return (this.decimalpoint1 = Number(0));
      } else {
        this.male = ((source[0].y / total) * 100).toFixed(1);
        this.female = ((source[1].y / total) * 100).toFixed(1);

        if (this.male == '100.0' || this.female == '100.0') {
          return (this.decimalpoint1 = Number(0));
        } else {
          this.decimalpoint1;
        }
      }
    },
    // 开启静态任务 数据是静态的
    startStaticIntervalTask() {
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      let chartsAnimation = this.Configuration?.propertyData?.chartsAnimation?.value;
      if (ChartsData?.currenEntry === 'staticData' && chartsAnimation?.isUseStaticRefresh) {
        // console.log('使用静态任务');
        let func = () => {
          let data = this.$_.cloneDeep(ChartsData.staticData);

          data.source.forEach(item => {
            item.y = 1;
          });

          this.setEchartsOptions(data);
          setTimeout(() => {
            this.setEchartsOptions(this.$_.cloneDeep(ChartsData.staticData));
          }, 0);
        };
        clearInterval(this.staticIntervalTaskID);
        func();

        this.staticIntervalTaskID = setTimeout(() => {
          console.log('任务执行staticData');
          console.log(chartsAnimation);
          func();
        }, chartsAnimation?.staticRefreshIntervalTime * 1000);

        this.staticIntervalTaskID2 = setTimeout(() => {
          func();
        }, (chartsAnimation?.staticRefreshIntervalTime - 2 <= 0 ? 1 : chartsAnimation?.staticRefreshIntervalTime - 2) * 1000);
      } else if (ChartsData?.currenEntry === 'staticData') {
        console.log('无静态任务 执行staticData');
        this.setEchartsOptions(ChartsData.staticData);
      }
    },
    // 开启api动态任务 数据是动态的
    async startApiIntervalTask() {
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      // 判断是否使用apiData，使用动态interval请求
      if (ChartsData?.currenEntry === 'apiData' && ChartsData?.apiData?.isUseInterval) {
        // 开启interval任务 间隔请求
        let func = async () => {
          let res = await this.getApiDataResByFilterAndResponseQuery();
          this.setEchartsOptions(res);
        };
        func();
        this.apiIntervalTaskID = setTimeout(async () => {
          // console.log('开启interval任务 间隔请求');
          func();
        }, ChartsData?.apiData?.apiInterval * 1000);
        // console.log(ChartsData?.apiData?.apiInterval);
      } else if (ChartsData?.currenEntry === 'apiData') {
        // console.log('不开启interval任务 只处理一次请求');
        let res = await this.getApiDataResByFilterAndResponseQuery();
        this.setEchartsOptions(res);
      }
    },
    // promise 返回api链接的请求数据
    getApiDataRes() {
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      let that = this;
      return new Promise((resolve, reject) => {
        if (!ChartsData) resolve('Error ChartsData 不存在！');
        if (!ChartsData.apiData?.apiUrl) resolve('Error apiUrl 不存在！');
        let header;
        if (ChartsData.apiData?.isUseUserKey) {
          let user_key = localStorage.getItem('user_key');

          if (user_key == 'undefined' || user_key == 'null' || user_key == null) user_key = this.$userKey;
          header = {
            userkey: user_key,
          };
        } else {
          header = {};
        }
        if (ChartsData.apiData?.apiUrlMethod == 'get') {
          let param = {
            method: ChartsData.apiData.apiUrlMethod,
            url: ChartsData.apiData.apiUrl,
            params: this.params,
            headers: header,
          };
          request(param)
            .then(res => {
              let data = this.$_.cloneDeep(res);
              resolve(data);
            })
            .catch(err => {
              reject(err);
            });
        } else {
          let param = {
            method: ChartsData.apiData.apiUrlMethod,
            url: ChartsData.apiData.apiUrl,
            params: this.params,
            headers: header,
          };

          request(param)
            .then(res => {
              let data = this.$_.cloneDeep(res);
              resolve(data);
            })
            .catch(err => {
              reject(err);
            });
        }
      });
    },
    // promise 返回api链接的请求数据 使用ResponseQuery
    getApiDataResByResponseQuery() {
      return new Promise((resolve, reject) => {
        let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
        if (!ChartsData) reject('Error ChartsData 不存在！');
        this.getApiDataRes()
          .then(res => {
            // query数据
            let arryQuery = ChartsData.apiData.apiResponseQuery.split('.');
            if (arryQuery.length >= 1) {
              arryQuery.forEach(item => {
                res = res[item];
              });
            }
            console.log('getApiDataResByResponseQuery');
            let data = this.$_.cloneDeep(res);
            resolve(data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // promise 返回api链接的请求数据 使用ResponseQuery和过滤器函数
    getApiDataResByFilterAndResponseQuery() {
      return new Promise((resolve, reject) => {
        let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
        if (!ChartsData) reject('Error ChartsData 不存在！');
        let filter = function (data, filter_text) {
          let dataSet = {};
          eval(filter_text);
          return dataSet;
        };
        this.getApiDataRes()
          .then(res => {
            // query数据
            let arryQuery = ChartsData.apiData.apiResponseQuery.split('.');
            if (arryQuery.length >= 1) {
              arryQuery.forEach(item => {
                res = res[item];
              });
            }
            // 判断是否使用过滤器
            if (ChartsData.apiData.isUseFilter) {
              res = filter(res, ChartsData.apiData.apiFilter);
            }
            // console.log('getApiDataResByFilterAndResponseQuery');
            // console.log(res);
            let data = this.$_.cloneDeep(res);
            resolve(data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
  },

  Configuration: {
    componentTitle: '男女比例',
    componentName: 'Others11Charts',
    componentOverViewImg: './img/charts/OthersCharts/Others11Charts.png',
    id: '',
    style: {
      width: 330,
      height: 194,
      left: 0,
      top: 0,
    },
    isScaling: false,
    isMoving: false,
    propertyData: {
      titleText: {
        value: '图表标题',
        lable: '图表标题',
        propertyComponentName: 'SingleInputor',
      },

      borderConfig: {
        propertyComponentName: 'ChartsBorderConfiger',
        value: {
          borderComponentName: 'Charts1Border',
        },
      },
      chartsColor: {
        propertyComponentName: 'ArrayColorSelector',
        value: {
          chartColor: [
            'rgba(223,65,56,1)',
            'rgba(229,115,63,1)',
            'rgba(240,189,108,1)',
            'rgba(237,214,102,1)',
            'rgba(77,168,222,1)',
            'rgba(25,168,164,1)',
          ],
          chartBackgroundColor: 'rgba(34, 46, 57, 0.04)',
        },
      },
      ChartsData: {
        lable: '数据接入',
        propertyComponentName: 'ChartsDataConfigor',
        value: {
          currenEntry: 'staticData',
          apiData: {
            apiUrl:
              'https://restapi.amap.com/v3/weather/weatherInfo?city=%E6%9D%AD%E5%B7%9E&output=json&key=db5d2728c584e5884c385c2a509b29b9&extensions=all',
            // apiUrl:
            // 'http://192.168.0.173/gthmmc_v4.0/gthmmc/index.php?m=sdms&c=dataMange&a=completeStatisticsdata&data=%7B%22type%22:%22%E6%80%BB%E6%95%B0%22,%22date_start%22:%222021-03-01%22,%22date_end%22:%222021-03-31%22%7D&directory_code=pro_ownerstatistics&type=day',
            apiResponseQuery: 'data.forecasts',
            isUseFilter: true,
            apiFilter: `
          // 可以使用data访问api请求的响应结果        
let seriesList = []

let seriesListKey = 'city'
let seriesListChildrenKey = 'casts'

data.forEach((item) => {
  seriesList.push(item[seriesListKey])
})
dataSet.seriesList = seriesList
dataSet.source = []
data.forEach((item) => {
  item[seriesListChildrenKey].forEach(item2 => {
    dataSet.source.push({
      s: item[seriesListKey],
      x: item2.date,
      y: item2.daytemp
    })
  })
})
          `,
            apiUrlMethod: 'get',
            isUseInterval: true,
            apiInterval: 10,
            apiUrlMethod: 'get',
            apiPostParams: '',
            isUseUserKey: true, // 是否使用user_key
          },
          staticData: {
            seriesList: ['人数'],
            source: [
              {
                s: '人数',
                x: '男',
                y: 100,
              },
              {
                s: '人数',
                x: '女',
                y: 1010,
              },
            ],
          },
        },
      },
      posSize: {
        lable: '位置尺寸',
        propertyComponentName: 'ChartsPosSizeConfiger',
        value: {
          width: 450,
          height: 200,
          left: 0,
          top: 0,
        },
      },
      fontStyle: {
        lable: '图表文字样式',
        propertyComponentName: 'ChartsFontStyleConfiger',
        value: {
          titleSize: 16,
          titleColor: '#ccc',
          xAxisSize: 20,
          xAxisColor: 'rgba(96, 231, 255, 1)',
          yAxisSize: 20,
          yAxisColor: 'rgba(15, 237, 146, 1)',
        },
      },

      chartsGrid: {
        lable: '图表定位',
        propertyComponentName: 'ChartsGridConfiger',
        value: {
          left: '5%',
          right: '10%',
          bottom: '0%',
          top: '0%',
        },
      },
      showStatus: {
        value: 'norm',
      },
      chartsOpicity: {
        propertyComponentName: 'ChartsOpicityConfiger',
        value: 1,
      },
      chartsAnimation: {
        propertyComponentName: 'ChartsAnimationConfiger',
        value: {
          isUseAnimation: false,
          isUseStaticRefresh: false,
          staticRefreshIntervalTime: 5,
        },
      },
      chartsRightDropDown: {
        propertyComponentName: 'ChartsRightDropDownConfiger',
        value: {
          isShowRightDropDownBox: false,
        },
      },
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped lang="scss">
.Others11Charts {
  color: white;
  width: 100%;
  height: 100%;
  .TableDateDownSelect {
    position: absolute;
    top: 2px;
    right: 4px;
  }

  .male-female {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    .human {
      width: 45%;
      display: flex;
      flex-direction: column;
      .img-data {
        display: flex;
        align-items: center;
        justify-content: space-around;
        .data {
          display: flex;
          flex-direction: column;
          margin-left: 10%;
          justify-content: space-between;
          // align-items: center;
          .percentage {
            // font-family: 'pfd';
            font-weight: bold;
            color: #fff !important;
          }
          span.sex {
            color: #b1d3fd;
          }
        }
      }
      // 进度条
      .progress {
        width: 100%;
        background: #031b441c;
        border-radius: 6px;
        margin-top: 20px;
        .d-male {
          width: 50%;
          height: 4px;
          background: linear-gradient(to right, #02302d, #00fae7);
          border-radius: 4px;
        }
        .d-famale {
          width: 50%;
          height: 4px;
          background: linear-gradient(to right, #3a023a, #e930eb);
          border-radius: 4px;
        }
        .p-data {
          transition: all 0.3s ease-in-out;
        }
      }
    }
  }
  .V11Style {
    .d-male {
      background: linear-gradient(to right, #09110e, #f59100) !important;
    }
    .d-famale {
      background: linear-gradient(to right, #180416, #058ebe) !important;
    }
    .img-data .data span.sex {
      color: #fff !important;
    }
    .human {
      align-items: flex-start !important;
    }

    .human .img-data .data {
      margin-left: 6% !important;
    }
    .human .img-data {
      justify-content: flex-start !important;
      width: 100% !important;
    }
  }
  .echarts {
    width: 100%;
    height: 100%;
  }
}
</style>
